import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { cartsControlRedirectSearch } from '~/components/routes/cameras/cart-control/cart-control'
import { CartControlStandalonePage } from '~/components/routes/cameras/cart-control/cart-control-standalone-page'
import { readHeldKiosks } from '~/components/routes/cameras/cart-control/held-kiosks'
import { CAMERA_STREAM_READ, CART_CONTROL_READ } from '~/components/routes/cameras/permissions'
import { withRoutePermissions } from '~/utils/rbac'
import { isPermissionSatisfied } from '~/utils/rbacModuleIndex'

/**
 * `/carts-control` — l'ancien écran « Contrôle panier », devenu le panneau « Contrôle du panier »
 * de l'écran Caméras (14/10). Avec le flux caméra, l'URL y mène (favoris, liens déjà envoyés) : le
 * panneau s'ouvre sur la caisse demandée (`?controle`), sinon sur celle que ce poste tient. Sans
 * lui, l'écran Caméras reste fermé et la vidéo aussi : la page montre le panneau seul. La garde
 * reste celle de l'ancien écran : la consultation OU la prise de main.
 */
export const Route = createFileRoute('/_authenticated/carts-control')({
  staticData: {
    permission: CART_CONTROL_READ,
  },
  validateSearch: z.object({
    storeId: z.number().int().positive().optional().catch(undefined),
    controle: z.number().int().positive().optional().catch(undefined),
  }),
  beforeLoad: ({ context, search }) => {
    if (!isPermissionSatisfied(context.ability, CAMERA_STREAM_READ)) return
    throw redirect({
      to: '/cameras/new',
      search: cartsControlRedirectSearch({ ...search, held: readHeldKiosks() }),
      replace: true,
    })
  },
  component: CartControlStandalonePage,
})
withRoutePermissions(Route)
